import {fromJS} from 'immutable'

/**
 * Actions
 */
const SHOW_MODAL = 'expii/modal/SHOW_MODAL'
const HIDE_MODAL = 'expii/modal/HIDE_MODAL'


/**
 * Reducer
 */
const defaultModalState = fromJS({
  modalType: null,
  modalProps: {}
})

export default function reducer(state = defaultModalState, action = {}) {
  switch (action.type) {
  case SHOW_MODAL:
    return state.merge(fromJS({
      modalType: action.modalType,
      modalProps: action.modalProps,
    }))
  case HIDE_MODAL:
    return defaultModalState
  default:
    return state
  }
}

/**
 * Action Creators
 */
export function showModal(modalType, modalProps) {
  return { type: SHOW_MODAL, modalType, modalProps }
}

export function hideModal() {
  return { type: HIDE_MODAL }
}

/**
 * Selectors
 */
export const selectModal = (state) => {
  const domain = state.get('modal')
  return {
    modalType: domain.get('modalType'),
    modalProps: domain.get('modalProps')
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/modal.js